import { render } from "./TypingDialog.vue?vue&type=template&id=4ac57c2e"
import script from "./TypingDialog.vue?vue&type=script&lang=js"
export * from "./TypingDialog.vue?vue&type=script&lang=js"

import "./TypingDialog.vue?vue&type=style&index=0&id=4ac57c2e&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__